import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import {
  ScheduleConfirmation,
  SelectionOfProfessionals,
  PackageSelector,
  ScheduleReminder,
  Home,
} from '../pages';
import PermissedRoute from './PermissedRoute';
import { MenuSlug } from '../state/types';

const MessagingSignedRoutes = () => (
  <Switch>
    <PermissedRoute
      exact
      path="/comunicacao/confirmacao-de-agenda"
      component={ScheduleConfirmation}
      permission={MenuSlug.CONFIRMATION}
    />

    <PermissedRoute
      exact
      path="/comunicacao/pacote-de-mensagem"
      component={SelectionOfProfessionals}
      permission={MenuSlug.PACKAGE}
    />

    <PermissedRoute
      exact
      path="/comunicacao/lembrete-de-agenda"
      component={ScheduleReminder}
      permission={MenuSlug.REMINDER}
    />

    <Route exact path="/comunicacao" component={Home} />

    <Route
      exact
      path="/comunicacao/pacote-de-mensagem/escolher-pacote"
      component={PackageSelector}
      permission={MenuSlug.PACKAGE}
    />

    <Route
      exact
      path="/comunicacao/pacote-de-mensagem/detalhes"
      component={() => {
        window.location.href = '/v2/comunicacao/pacote-de-mensagem/detalhes';
        return null;
      }}
    />

    <Redirect to="/404" />
  </Switch>
);

export { MessagingSignedRoutes };
